import { jsx as o, jsxs as d } from "react/jsx-runtime";
import { useId as f } from "react";
import { Frame as m } from "../Frame/Frame.js";
import { cx as t } from "../styled-system/css/cx.js";
import { css as e } from "../styled-system/css/css.js";
function a({ children: l, layout: n }) {
  const i = m.useFrame(), c = f();
  return n ?? (n = i.mode === "dialog" ? "compact" : "full"), /* @__PURE__ */ o(
    "div",
    {
      className: t(
        e({
          display: "flex",
          flex: "0 0 auto",
          flexDirection: "column",
          width: "100%"
        }),
        n === "compact" && e({
          minHeight: 0
        }),
        n === "full" && e({
          "@container (min-width: 480px)": {
            overflowY: "hidden"
          },
          flex: "1 1 auto",
          minHeight: 120,
          overflowY: "auto"
        })
      ),
      ref: (r) => {
        i.setScreen(r, c);
      },
      children: /* @__PURE__ */ o(
        "div",
        {
          className: t(
            e({
              display: "flex",
              flex: "1 1 auto",
              flexDirection: "column",
              minHeight: 0,
              position: "relative",
              width: "100%"
            })
          ),
          children: /* @__PURE__ */ o(
            "div",
            {
              className: t(
                e({
                  display: "flex",
                  flexDirection: "column",
                  width: "100%"
                }),
                n === "full" && e({
                  "@container (min-width: 480px)": {
                    flex: "0 0 auto",
                    padding: 12
                  },
                  flex: "1 1 auto"
                })
              ),
              children: l
            }
          )
        }
      )
    }
  );
}
function s({
  content: l,
  icon: n,
  layout: i,
  title: c
}) {
  const r = m.useFrame();
  return i ?? (i = r.mode === "dialog" ? "compact" : "full"), /* @__PURE__ */ d(
    "div",
    {
      className: t(
        e({
          display: "flex",
          flexDirection: "column",
          gap: 6,
          lineHeight: 1.5
        }),
        i === "compact" && e({
          paddingBottom: 8
        }),
        i === "full" && e({
          "@container (min-width: 480px)": {
            paddingBottom: 40
          },
          flex: "1 0 auto",
          justifyContent: "center",
          paddingBottom: 16
        })
      ),
      children: [
        /* @__PURE__ */ d(
          "div",
          {
            className: t(
              e({
                alignItems: "center",
                display: "flex",
                justifyContent: "flex-start"
              }),
              i === "compact" && e({
                gap: 8
              }),
              i === "full" && e({
                flexDirection: "column",
                gap: 16
              })
            ),
            children: [
              n && /* @__PURE__ */ o(
                "div",
                {
                  className: t(
                    e({
                      "& > svg": {
                        height: "62.5%",
                        width: "62.5%"
                      },
                      backgroundColor: "var(--background-color-th_badge-info)",
                      borderRadius: "50%",
                      color: "var(--text-color-th_badge-info)",
                      display: "grid",
                      overflow: "hidden",
                      placeItems: "center"
                    }),
                    i === "compact" && e({ height: 32, width: 32 }),
                    i === "full" && e({ height: 64, width: 64 })
                  ),
                  children: n
                }
              ),
              /* @__PURE__ */ o(
                "div",
                {
                  className: t(
                    i === "compact" && e({ fontSize: 18 }),
                    i === "full" && e({ fontSize: 28 })
                  ),
                  children: c
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ o(
          "div",
          {
            className: t(
              i === "compact" && e({
                fontSize: 15,
                textAlign: "left"
              }),
              i === "full" && e({
                fontSize: 18,
                textAlign: "center"
              })
            ),
            children: l
          }
        )
      ]
    }
  );
}
((l) => {
  l.Header = s;
})(a || (a = {}));
export {
  a as Screen
};
//# sourceMappingURL=Screen.js.map
